import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Tab, Accordion, Form } from 'react-bootstrap';
import { matchPath, NavLink, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { SubNav } from '../layout/submenu';
import { searchWord, isRangeChanged, isToday, isCustom, usePermission, validateCollections } from '../../helpers/common';
import { deleteCrew, getCrewList as getCrew, updateActiveStatus, selectedCrew } from '../../actions/crew';
import { getCrewInfo, getCrewList as getCrewListV1 } from "../../actions/crew-kanban";
import { filterMapEgList, clearMapFilters, setReplayParams } from '../../actions/map';
import { planAnalyzeInfo, crewAnalyzeInfo, setSearchParams, egAnalyzeInfo } from '../../actions/analyze';
import { Modal } from '../widgets';
import { CrewCard } from './CrewCard';
import { CustomAccordionToggle } from "./CustomAccordionToggle";
import {
    RANGE_TYPE_TODAY, RANGE_TYPE_CUSTOM, RANGE_TYPE_ABSOLUTE,
    API_DATETIME_FORMAT,
    NON_FIELD_SHAPE_LIST_TYPE
} from '../../constants';
import { getEquipmentGroupList } from '../../actions/equipment-group';
import { EquipmentGroupCard } from './EquipmentGroupCard';
import { getDrawingInstance } from '../map/geo/DrawingControl';

const CrewSubList = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const location = useLocation();
    const history = useHistory();
    const match = useRouteMatch();
    const searchInput = React.createRef();

    const timezone = useSelector((state => state.farm.currentFarm.timezone_identifier));
    const isRequesting = useSelector((state => state.crew.isRequesting));
    const crewList = useSelector((state => state.crew.crewList));
    const selectedCrewV1 = useSelector((state => state.crewKanban.crews));
    const selectedCrewId = useSelector((state => state.crew.selectedCrew));
    const equipmentGroupList = useSelector((state => state.equipmentGroup.equipmentGroupList));
    const selectedPlanType = useSelector((state => state.plan.selectedPlanType));
    const isAllPlan = useSelector((state => state.plan.isSelectAllPlan));
    const search = useSelector((state => state.analyze.searchParams));
    const geoRegionList = useSelector(state => state.geo.regionsList);
    const { range, custom } = search;


    const [selecetedSearch, setSelectedSearch] = useState(null);
    const [pervSelectedPlanType, setPrevPlanType] = useState(null);
    const [isSelectedAllPlan, setSelectedAllPlan] = useState(false);
    const [crewData, setCrewData] = useState({
        searchText: '',
        deleteModal: false,
        isEditMode: false,
        farmId: 0,
        deleteCrewId: null,
        selectedCrewId: null,
        paramCrewId: null,
        crewName: '',
        rootUrl: '',
        showDateConfirm: false,
        isAutoDate: false,
        selectedEGId: null,
        isShowAll: false
    });
    let drawing = getDrawingInstance();

    const regionShapesByCrew = () => {
        if (crewData.selectedCrewId) {
            const crewInfo = selectedCrewV1[crewData.selectedCrewId] && selectedCrewV1[crewData.selectedCrewId].info ?
                selectedCrewV1[crewData.selectedCrewId].info : null;
            if (crewInfo && crewInfo.is_active_all_shapes) return;
            const geoRegionListByCrew = crewInfo ? crewInfo.geo_region_list : [];
            const selectedRegionIds = getGeoRegionShapIds(geoRegionListByCrew);
            const nonFieldShapeList = geoRegionList.filter(it => NON_FIELD_SHAPE_LIST_TYPE.includes(it.geo_region_type_id));
            const nonFieldShapeIds = getGeoRegionShapIds(nonFieldShapeList);
            if (validateCollections(selectedRegionIds)) {
                drawing.showShapeGroups([...selectedRegionIds, ...nonFieldShapeIds] || [], true);
            }
        }
    }

    useEffect(() => {
        searchInput.current.focus();
        const { farmId } = params;
        const matchv1 = getMatch();
        let paramCrewId = null;
        if (matchv1 && matchv1.params && matchv1.params.crewId) paramCrewId = matchv1.params.crewId;
        else dispatch(planAnalyzeInfo(farmId));

        setCrewData({ ...crewData, farmId, paramCrewId, rootUrl: `/home/farm/${farmId}/crew` });
        if (range) {
            getCrewList();
            getEgList();
        }

        if (search) {
            setSelectedSearch(search);
        }

        if (isAllPlan) {
            setSelectedAllPlan(isAllPlan);
            setCrewData({ ...crewData, isShowAll: isAllPlan });
        }
        dispatch(getCrewListV1({ farmId }));
    }, []);

    useEffect(() => {
        if (crewList.length > 0 && crewData.paramCrewId && !crewData.selectedCrewId) {
            const find = crewList.filter(e => e.crew_uuid === crewData.paramCrewId);
            if (find.length > 0) handleCrewSelect(find[0]);
        }

        if ((selecetedSearch && selecetedSearch.hasOwnProperty("rangeId") && isRangeChanged(selecetedSearch, search)) ||
            (pervSelectedPlanType !== selectedPlanType) ||
            (isAllPlan !== isSelectedAllPlan)) {
            getCrewList();
            getEgList();
            setSelectedSearch(search);
            setPrevPlanType(selectedPlanType);
        }
        if (isAllPlan !== isSelectedAllPlan) {
            setSelectedAllPlan(isAllPlan);
            setCrewData({ ...crewData, isShowAll: isAllPlan });
        }

        if (crewList.length > 0 && crewData.selectedCrewId && selectedCrewId !== crewData.selectedCrewId) {
            const find = crewList.filter(e => e.crew_uuid === selectedCrewId);
            if (find.length > 0) handleCrewSelect(find[0]);
        }

    }, [crewList, search, selectedPlanType, isAllPlan, crewData.selectedCrewId]);

    useEffect(() => {
        return () => {
            dispatch(setReplayParams({ enable: true, enabledDate: null }));
            dispatch(clearMapFilters());
        }
    }, []);

    const getCrewList = (isShowAll = false) => {
        const { farmId } = params;
        dispatch(getCrew({
            farmId,
            fromDate: isCustom(range) ? custom.from : null,
            toDate: isCustom(range) ? custom.to : null,
            ...(!isShowAll && !isAllPlan) && { selectedPlanType: selectedPlanType }
        }));
    }

    const getEgList = () => {
        const { farmId } = params;
        dispatch(getEquipmentGroupList({ farmId }));
    }

    const handleSearchBox = (searchText) => {
        setCrewData({ ...crewData, searchText });
    }

    const handleDelete = (id, name, e) => {
        e.stopPropagation();
        setCrewData({ ...crewData, deleteCrewId: id, crewName: name, deleteModal: true });
    }

    const handleDeleteConfim = () => {
        dispatch(deleteCrew({
            crew_uuid: crewData.deleteCrewId,
            farm_uuid: crewData.farmId
        }, () => getCrewList()));
    }

    const handleFlag = (id) => {
        let active = null;
        crewList.forEach(e => { if (e.crew_uuid === id) active = e.active === 0 ? 1 : 0; });

        dispatch(updateActiveStatus({
            active,
            crew_uuid: id,
            farm_uuid: crewData.farmId
        }));
    }

    const handleSelect = (item) => {
        const { farmId } = params;
        dispatch(selectedCrew(item.crew_uuid));
        if (item.crew_uuid) dispatch(getCrewInfo([item.crew_uuid], { farmId }));
        handleCrewSelect(item);
    }

    const handleCrewSelect = (item) => {
        const crewId = item.crew_uuid;
        const { isAutoDate, farmId, selectedCrewId } = crewData;
        let replay = {};
        if (crewId === selectedCrewId) {
            const selectedRegionIds = getGeoRegionShapIds(geoRegionList);
            drawing.showShapeGroups(selectedRegionIds || [], true);
            history.push(`${match.url}?t=sub&sub=1`);
            setCrewData({ ...crewData, selectedCrewId: null, paramCrewId: null, selectedEGId: null });
            if (isAutoDate) {
                replay = { range: 1 };
                setTodayDate();
            }
            dispatch(selectedCrew(null));
            dispatch(setReplayParams({ enable: true, enabledDate: null, ...replay }));
            dispatch(clearMapFilters());
            dispatch(planAnalyzeInfo(farmId));
        } else {
            history.push(`${match.url}/${crewId}?t=sub&sub=1`);
            const isEndCrew = item.is_end_crew;
            if (!isEndCrew && isAutoDate) {
                replay = { range: 1 };
                setTodayDate();
            }
            dispatch(setReplayParams({ enable: !isEndCrew, enabledDate: null, ...replay }));
            dispatch(filterMapEgList({ crewIds: [crewId] }));
            dispatch(crewAnalyzeInfo(crewId, item.crew_name));
            let state = { selectedCrewId: crewId, selectedEGId: null };
            if (isEndCrew) state = { ...state, showDateConfirm: true };
            setCrewData({ ...crewData, ...state });
        }
    }

    const handleDateConfirm = () => {
        const crewItems = crewList.filter(e => e.crew_uuid === crewData.selectedCrewId);
        if (crewItems.length === 0) return;

        const crew = crewItems[0];
        if (!crew.is_end_crew) return;

        const date = {
            from: moment.utc(crew.start_date).format(API_DATETIME_FORMAT),
            to: moment.utc(crew.end_crew_date).tz(timezone).format(API_DATETIME_FORMAT)
        };
        const dateInfo = { custom: date, absolute: date };
        const searchParams = { range: RANGE_TYPE_CUSTOM, customRange: RANGE_TYPE_ABSOLUTE };

        dispatch(setReplayParams({ enable: true, enabledDate: { start: date.from, end: date.to }, range: 3 }));
        dispatch(setSearchParams({ ...searchParams, ...dateInfo }));
        setCrewData({ ...crewData, isAutoDate: true });
    }

    const handleDateCancel = () => {
        setTodayDate();
        dispatch(setReplayParams({ enable: true, enabledDate: null, range: 1 }));
        setCrewData({ ...crewData, showDateConfirm: !crewData.showDateConfirm, isAutoDate: false });
    }

    const setTodayDate = () => {
        if (isToday(range)) return;
        const now = moment.utc().tz(timezone);
        const dateObj = {
            from: now.clone().startOf("day").format(API_DATETIME_FORMAT),
            to: now.clone().endOf("day").format(API_DATETIME_FORMAT)
        };
        const dateInfo = { custom: dateObj, absolute: dateObj };
        const searchParams = { range: RANGE_TYPE_TODAY, customRange: RANGE_TYPE_TODAY };
        dispatch(setSearchParams({ ...searchParams, ...dateInfo }));
    }

    const getMatch = () => {
        return matchPath(location.pathname, {
            path: `${match.path}/:crewId?`,
            exact: false,
            strict: false,
        });
    }

    const getCrewName = () => {
        const crewItems = crewList.filter(e => e.crew_uuid === crewData.selectedCrewId);
        if (crewItems.length === 0) return;
        return crewItems[0].crew_name;
    }

    /* const getEGDetail = (id) => {
        const findEGItem = equipmentGroupList.filter(e => e.equipment_group_uuid === id);
        if (findEGItem.length === 0) return;
        return findEGItem[0];
    } */

    const getGeoRegionShapIds = (shapeList) => {
        let shapeIds;
        if (validateCollections(shapeList)) {
            shapeIds = shapeList.map(it => it.geo_region_uuid)
        }
        return shapeIds;
    }

    useEffect(() => {
        const { farmId } = params;
        if (crewData.selectedCrewId) {
            dispatch(getCrewInfo([crewData.selectedCrewId], { farmId }));
            regionShapesByCrew();
        }
    }, [crewData.selectedCrewId]);

    useEffect(() => {
        regionShapesByCrew();
    }, [selectedCrewV1]);

    const getCrewSubList = (list) => {
        const allow = usePermission();
        const isAllowEdit = allow("crew", "edit");
        const isAllowDelete = allow("crew", "delete");
        const today = isToday(range);

        return <Accordion>
            <SubNav.List>
                {list.map(e => {
                    const filteredEGList = equipmentGroupList.filter(item => item.crew.crew_uuid === e.crew_uuid);
                    return <React.Fragment key={e.crew_uuid}>
                        <CrewCard
                            item={e}
                            timezone={timezone}
                            today={today}
                            isAllowEdit={isAllowEdit}
                            isAllowDelete={isAllowDelete}
                            selected={!crewData.selectedEGId ? crewData.selectedCrewId : null}
                            onSelect={item => handleSelect(item)}
                            onDelete={handleDelete}
                            onPin={handleFlag}
                            eventKey={e.crew_uuid}
                            expand={filteredEGList.length > 0}
                        />
                        <Accordion.Collapse eventKey={e.crew_uuid} className="pl-2">
                            {renderEGList(filteredEGList)}
                        </Accordion.Collapse>
                    </React.Fragment>
                })}
            </SubNav.List>
        </Accordion>;
    }

    const renderEGList = (egList) => {
        return <>
            {egList.map(e => <EquipmentGroupCard
                key={e.equipment_group_uuid}
                item={e}
                selected={crewData.selectedEGId}
                onSelect={handleEGSelect}
            />)}
        </>
    }

    const getTypeWiseCrews = () => {
        const { searchText, selectedCrewId } = crewData;

        let pinList = [], unpinList = [], endedList = {}, expandYear = null;
        let fileteredList = crewList;

        if (searchText.trim().length > 0)
            fileteredList = fileteredList.filter(e => searchWord(e.crew_name, searchText));

        for (const item of fileteredList) {
            if (item.is_end_crew || !item.alive) {
                const year = moment.utc(item.start_date).year();
                if (!endedList[year]) endedList[year] = [];
                endedList[year].push(item);
                if (item.crew_uuid === selectedCrewId) expandYear = year.toString();
            }
            else item.active ? pinList.push(item) : unpinList.push(item);
        }
        return { fileteredList, pinList, unpinList, endedList, expandYear };
    }

    const handleEGSelect = (item) => {
        const { selectedCrewId, selectedEGId, farmId } = crewData;
        const egId = item.equipment_group_uuid;
        if (egId === selectedEGId) {
            setCrewData({ ...crewData, selectedEGId: null });
            if (selectedCrewId) {
                dispatch(crewAnalyzeInfo(selectedCrewId, getCrewName()));
            }
            else {
                dispatch(planAnalyzeInfo(farmId));
            }
        } else {
            setCrewData({ ...crewData, selectedEGId: egId });
            dispatch(egAnalyzeInfo(item.crew.crew_uuid, item.crews, egId, item.equipment_group_name, item.vehicle.is_truck));
        }
    }

    const { searchText, rootUrl, deleteModal, crewName, showDateConfirm } = crewData;
    const { pinList, unpinList, endedList, expandYear, fileteredList } = getTypeWiseCrews();

    return <SubNav className="submenu-crew">
        <SubNav.Subheader>
            <div className='title-container'>
                <aside className='section-title'>
                    Crews {crewList.length > 0 ? `(${crewList.length})` : ''}
                </aside>
                {!isAllPlan &&
                    <aside className='section-icon-container'>
                        <NavLink className="btn-kanban-crew" to={`${rootUrl}/kanban`} title="Manage Crews">
                            <i className="fa fa-pencil cursor-pointer" aria-hidden="true"></i>
                        </NavLink>
                        <Form className='crew-show-all'>
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                label="Show All"
                                checked={crewData.isShowAll}
                                disabled={isAllPlan}
                                onChange={e => {
                                    const isChecked = e.target.checked;
                                    getCrewList(isChecked);
                                    setCrewData({ ...crewData, isShowAll: isChecked });
                                }}
                            />
                        </Form>
                    </aside>
                }
            </div>

        </SubNav.Subheader>

        <SubNav.SearchBox
            ref={searchInput}
            placeholder="Crew name"
            value={searchText}
            onChange={e => handleSearchBox(e.target.value)}
            onClear={() => handleSearchBox("")}
        />

        <Tab.Container defaultActiveKey="0">
            <Tab.Content>
                <Tab.Pane eventKey="0" className="scroll-bar-2">
                    <div className="list-content">
                        {isRequesting && <SubNav.Loading />}
                        {!isRequesting && fileteredList.length === 0 && <SubNav.NotFound />}
                        {!isRequesting && fileteredList.length > 0 &&
                            <>
                                {pinList.length > 0 &&
                                    <Accordion className="accordion-list" defaultActiveKey="pinList">
                                        <CustomAccordionToggle eventKey='pinList' className="accordion-toggle">
                                            Pinned
                                        </CustomAccordionToggle>
                                        <Accordion.Collapse eventKey='pinList' className="accordion-collapse">
                                            {getCrewSubList(pinList)}
                                        </Accordion.Collapse>
                                    </Accordion>}

                                {unpinList.length > 0 &&
                                    <Accordion className="accordion-list" defaultActiveKey="unPinList">
                                        <CustomAccordionToggle eventKey='unPinList' className="accordion-toggle">
                                            Unpinned
                                        </CustomAccordionToggle>
                                        <Accordion.Collapse eventKey='unPinList' className="accordion-collapse">
                                            {getCrewSubList(unpinList)}
                                        </Accordion.Collapse>
                                    </Accordion>}

                                {(pinList.length + unpinList.length) > 0 && (Object.keys(endedList).length > 0) && <SubNav.Divider />}

                                <Accordion className="accordion-list" defaultActiveKey={expandYear}>
                                    {Object.keys(endedList)
                                        .sort((a, b) => b - a)
                                        .map(year =>
                                            <div key={year} className="mb-2">
                                                <CustomAccordionToggle eventKey={year} className="accordion-toggle">
                                                    {year}
                                                </CustomAccordionToggle>
                                                <Accordion.Collapse eventKey={year} className="accordion-collapse">
                                                    {getCrewSubList(endedList[year])}
                                                </Accordion.Collapse>
                                            </div>)}
                                </Accordion>
                            </>}
                    </div>
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>

        <Modal.Confirm
            show={showDateConfirm}
            onConfirm={handleDateConfirm}
            onCancel={handleDateCancel}
            onHide={() => setCrewData({ ...crewData, showDateConfirm: !crewData.showDateConfirm })}
            iconClassName="fa fa-question"
            title={{
                className: "confirm-date-title",
                content: `Crew ${getCrewName()} is ended already. Do you want to view the data for it?`
            }}
            variant="info"
            cancelButton={{ content: "Cancel", variant: "default" }}
            confirmButton={{ content: "Continue", variant: "info" }}
        />

        <Modal.Confirm
            show={deleteModal}
            onConfirm={handleDeleteConfim}
            onHide={() => setCrewData({ ...crewData, deleteModal: !crewData.deleteModal })}
            iconClassName="fa fa-trash"
            content={`Do you really want to delete these ${crewName}?`}
        />
    </SubNav>;

}

export default CrewSubList;